import { FunctionComponent, useLayoutEffect, useState } from 'react';
import PortalHeader from '@media-platform/portal-menu/src/components/PortalHeader';
import { portalHeaderConfig } from './Header.config';
import classnames from 'classnames';
import * as s from './Header.css';
import * as T from './Header.types';
export const PortalMenu: FunctionComponent<T.IPortalMenuProps> = (props) => {
    const { layout, isFixed, className, showMobilePromo } = props;
    const { menu, custom: { isMobile, project_name }, search, user, } = layout;
    const [pageUTM, setPageUTM] = useState<string>('');
    useLayoutEffect(() => {
        const { currentPageUTM } = window.UTMApi;
        setPageUTM(currentPageUTM as string);
    }, []);
    return (<PortalHeader className={classnames(s.root, className, 'rb-p-branding--header')} config={portalHeaderConfig({
            utm: pageUTM,
            projectName: project_name || 'Питомцы Mail',
            showMobilePromo,
            search,
            menuLinks: user?.menu_links,
        })} initIsMobile={isMobile} menu={menu} isFixed={isFixed}/>);
};
PortalMenu.displayName = 'PortalMenu';
